import { render } from "./LeaveComment.vue?vue&type=template&id=52c372de&scoped=true"
import script from "./LeaveComment.vue?vue&type=script&lang=js"
export * from "./LeaveComment.vue?vue&type=script&lang=js"

import "./leave-comment.scss?vue&type=style&index=0&id=52c372de&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c372de"]])

export default __exports__